import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';

// Konfiguracja Firebase dla aplikacji webowej NIE jest sekretem — i tak trafia
// do bundla wysyłanego do przeglądarki. Bezpieczeństwo danych zapewniają reguły
// Firestore, a nie ukrycie tych wartości.
// Zmienne środowiskowe pozwalają jednak wskazać inny projekt (np. testowy)
// bez zmiany kodu — wystarczy plik .env.local. Bez nich używane są wartości
// dotychczasowego projektu produkcyjnego, więc nic się nie psuje.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyAdNCFaVMyVDOljirwomOm2ogpsYoJcE60',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'depot-d92e3.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'depot-d92e3',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'depot-d92e3.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '1083957929884',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:1083957929884:web:1d242f9b90beea97d40a59',
};

// Inicjalizacja na poziomie modułu, a nie w useState/useEffect komponentu.
// Poprzednio App.js trzymał instancje Firebase w stanie Reacta i przekazywał je
// przez propsy w dół drzewa (`db={db}` do każdego widoku). Moduł jest naturalnym
// singletonem — instancje powstają raz i można je importować tam, gdzie są
// potrzebne, bez przeciągania przez propsy.
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Trwała pamięć podręczna zamiast domyślnej, ulotnej.
//
// Daje trzy rzeczy istotne przy pracy na bramie:
//  - aplikacja działa przy zerwanym połączeniu — odczyty idą z dysku,
//    a zapisy czekają w kolejce i same się wysyłają po powrocie sieci,
//  - kolejne wejścia ładują się z lokalnej kopii, a nie z sieci, więc lista
//    kontenerów pojawia się natychmiast,
//  - odczyty obsłużone z pamięci podręcznej nie są naliczane przez Firestore.
//
// persistentMultipleTabManager pozwala trzymać aplikację otwartą w kilku
// kartach naraz. Bez niego pierwsza karta blokuje pamięć podręczną na
// wyłączność, a w pozostałych trwałość po cichu się nie włącza.
//
// initializeFirestore (nie getFirestore) musi być wywołane zanim cokolwiek
// sięgnie po instancję bazy — dlatego dzieje się to tutaj, na poziomie modułu.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});

export default app;
